import { Action } from 'redux';
import { ContractConcept } from '../../../models/Entities/Contracts/ContractConcept';
import { ContractConceptState, ContractConceptUnloadState } from '../../states/ContractConceptState';


export default function ContractConceptDeleteReducer(
  state: ContractConceptState | undefined,
  action: Action
): ContractConceptState {
  const currentState = state ?? ContractConceptUnloadState;
  const a: any = action;
  let CurrentConcept: ContractConcept | undefined;

  switch (a.type) {
    case 'CONTRACTCONCEPT_DELETE_REQUEST_ACTION':
      return {
        ...currentState,
        isDeletingOne: true,
        isDeletingOneSuccess: undefined,
        FailDeletingOne: false,
      };
    
    case 'CONTRACTCONCEPT_DELETE_RECEIVE_ACTION':
      return {
        ...currentState,
        isDeletingOne: false,
        isDeletingOneSuccess: true,
        FailDeletingOne: false,
      };
    
    case 'CONTRACTCONCEPT_DELETE_FAIL_ACTION':
      return {
        ...currentState,
        isDeletingOne: false,
        isDeletingOneSuccess: false,
        FailDeletingOne: true,
        error: a.error,
      };
    
    default:
      return currentState;
  }
}
